module.exports = __webpack_public_path__ + "img/image.7396f7c5.svg";